export class WeeklyNews {
    _id: string;
    weeklyNo: number;
    date: Date;
    creator: string;
    body: string;
    header: string;
    image: any;
    likes: Likes[];
    dislikes: Dislikes[];
    lastViewed: Date;
    shortDesc: string;
    comments: Array<Comments>;
    viewPage: ViewPage[];
    constructor(weeklyNews?) {
        weeklyNews = weeklyNews || {};
        this._id = weeklyNews._id || null;
        this.weeklyNo = weeklyNews.weeklyNo || null;
        this.date = weeklyNews.date || new Date();
        this.creator = weeklyNews.creator || null;
        this.body = weeklyNews.body || null;
        this.header = weeklyNews.header || null;
        this.image = weeklyNews.image || null;
        this.likes = weeklyNews.likes || [];
        this.dislikes = weeklyNews.dislikes || [];
        this.lastViewed = weeklyNews.lastViewed || new Date();
        this.shortDesc = weeklyNews.shortDesc || null;
        this.comments = weeklyNews.comments || [];
        this.viewPage = weeklyNews.viewPage || [];
    }
}

export class Comments {
    date: Date;
    name: string;
    comment: string;
    email: string;
    replies: Array<Replies>;
    id: string;
    constructor(comments) {
        comments = comments || {};
        this.date = comments.date ? comments.date : new Date();
        this.name = comments.name ? comments.name : '';
        this.comment = comments.comment ? comments.comment : '';
        this.email = comments.email ? comments.email : '';
        this.replies = comments.replies ? comments.replies : [];
        this.id = comments.id ? comments.id : [];
    }
}

export interface Likes {
    date: Date;
    name: string;
    email: string
}

export interface Dislikes {
    date: Date;
    name: string;
    email: string
}

export interface ViewPage {
    date: Date;
    name: string;
    email: string;
}

export class Replies {
    id: string;
    date: Date;
    name: string;
    comment: string;
    email: string;
    constructor(replies?) {
        replies = replies || {};
        this.id = replies.id ? replies.id : '';
        this.date = replies.date ? replies.date : new Date();
        this.name = replies.name ? replies.name : '';
        this.comment = replies.comment ? replies.comment : '';
        this.email = replies.email ? replies.email : '';
    }
}


// WEBPACK FOOTER //
// ./src/model/weeklynews.ts